import { memo } from 'react'

import { copy } from '~/modules/lunya'
import { ValueField } from '~/shared/ui'

import type { BirthTimeFieldProps } from './types'

/** Время рождения — необязательное поле, 54px `surface-alt` (спека 02 §A2). */
export const BirthTimeField = memo(function BirthTimeField(props: BirthTimeFieldProps) {
  const { value, isActive = false, onPress } = props

  return (
    <ValueField
      label={copy.onb.a2.time}
      value={value}
      iconName='clock'
      isActive={isActive}
      onPress={onPress}
    />
  )
})
